/** Turn axios / fetch errors into a user-visible message. */
export function apiErrorMessage(err, fallback = "Request failed", options = {}) {
  if (!err) return fallback;

  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    if (/findMany|reading 'count'|Prisma delegate missing/i.test(detail)) {
      return "Crypto database models are not ready. Restart the backend after running: npx prisma generate && npx prisma migrate deploy";
    }
    return detail;
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => (typeof d === "string" ? d : d?.msg || d?.message))
      .filter(Boolean);
    if (parts.length) return parts.join("; ");
  }

  const envelopeMsg = err?.response?.data?.message || err?.response?.data?.msg;
  if (typeof envelopeMsg === "string" && envelopeMsg.trim() && envelopeMsg.toLowerCase() !== "success") {
    return envelopeMsg;
  }

  const status = err?.response?.status;
  if (status === 413) return "File is too large (maximum 10MB)";
  if (status === 403) {
    const msg = err?.response?.data?.message;
    if (typeof msg === "string" && msg.trim()) return msg;
    return detail || "Request blocked — refresh the page and try again";
  }
  if (status === 401) return "Session expired — sign in again";
  if (status >= 500) return "Server error — try again in a moment";

  if (err?.code === "ERR_NETWORK" || !err?.response) {
    if (options.upload) {
      return "Upload failed — the file may be too large (maximum 10MB). Try a smaller or compressed file.";
    }
    return "Could not reach the server. Check your connection and that the API is running.";
  }

  const msg = err?.message || "";
  if (/maximum call stack/i.test(msg)) {
    return "This file is too large to process in the browser. Use a smaller file (under 10MB).";
  }
  if (/network error/i.test(msg)) {
    return options.upload
      ? "Upload failed — check your connection or use a smaller file (maximum 10MB)."
      : "Network error — check your connection and try again.";
  }
  if (msg.trim()) return msg;

  return fallback;
}
